<template>
  <div class="cipherDataQuery-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-dynamic"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="公司组织ID"
            prop="orgid"
            :rules="{ required: true, message: '请选择公司组织ID', trigger: 'blur' }"
          >
            <!-- <el-input v-model="formDate.orgid" placeholder="请输入组织ID"></el-input> -->
            <el-select
              v-model="formDate.orgid"
              placeholder="请选择公司组织ID"
              clearable
              disabled
              class="auto-width"
            >
              <el-option
                v-for="item in orgOtion"
                :key="item.OrgId"
                :label="item.OrgName"
                :value="item.OrgId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="系统参数路径"
            prop="path"
            :rules="{ required: true, message: '请输入系统参数路径', trigger: 'blur' }"
          >
            <el-input v-model="formDate.path" placeholder="请输入系统参数路径"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="链上交易ID"
            prop="path"
            :rules="{ required: true, message: '请输入链上交易ID', trigger: 'blur' }"
          >
            <el-input v-model="formDate.txid" placeholder="请输入链上交易ID"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- <el-form-item v-for="(ele, index) in formDate.ids" :key="index" label="身份ID" :rules="{required: true, message: '请输入身份ID', trigger: 'blur'}">
        <el-input v-model="ele.id"></el-input
        ><el-button @click.prevent="removeId(ele)">删除</el-button>
      </el-form-item> -->

          <el-form-item
            v-for="(ele, index) in formDate.ids"
            :key="`id${index}`"
            label="用户身份ID"
            :prop="`ids.${index}.id`"
            :rules="[{ required: true, message: '用户身份ID不能为空', trigger: 'blur' }]"
          >
            <el-input v-model="ele.id"></el-input>
            <el-button @click.prevent="removeId(ele)">删除</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- <el-form-item v-for="(ele, index) in formDate.ids" :key="index" label="对应身份密钥路径" :rules="{required: true, message: '请输入对应身份密钥路径', trigger: 'blur'}">
        <el-input v-model="ele.prvpath"></el-input
        ><el-button @click.prevent="removeId(ele)">删除</el-button>
      </el-form-item> -->

          <el-form-item
            v-for="(ele, index) in formDate.ids"
            :key="`path${index}`"
            label="对应身份密钥路径"
            :prop="`ids.${index}.id`"
            :rules="[{ required: true, message: '对应身份密钥路径不能为空', trigger: 'blur' }]"
          >
            <el-input v-model="ele.prvpath"></el-input>
            <el-button @click.prevent="removeId(ele)">删除</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item v-if="formDate.params" label="data" prop="path">
            <el-input
              v-for="(ele, index) in formDate.params"
              :key="index"
              disabled
              :value="ele"
              class="input-data"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handleCipherDataOnchain">确定</el-button>
            <el-button @click="addIds">新增ID</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 136
  },
  data() {
    return {
      formDate: {
        msg: '',
        params: '',
        txid: '',
        ids: [
          {
            id: '',
            prvpath: ''
          }
        ],
        orgid: '',
        chainid: this.$route.query.chainId,
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        path: ''
      },
      orgOtion: []
    }
  },
  mounted() {
    if (localStorage.getItem('orgid')) {
      this.formDate.orgid = localStorage.getItem('orgid')
    }
    if (localStorage.getItem('ids')) {
      this.formDate.ids = JSON.parse(localStorage.getItem('ids'))
    } else {
      this.formDate.ids = [
        {
          id: '',
          prvpath: ''
        }
      ]
    }
    this.getOptions()
  },
  methods: {
    getOptions() {
      this.$apis.chain
        .getChainOrgList({ limit: 1000, offset: 0, chainId: this.$route.query.chainId })
        .then(res => {
          if (res.data && res.data.items) {
            let hasObj = {}
            this.orgOtion = res.data.items.reduce((result, cur) => {
              if (!hasObj[cur.OrgId]) {
                hasObj[cur.OrgId] = true
                result.push(cur)
              }
              return result
            }, [])
          }
        })
    },

    handleCipherDataOnchain() {
      this.$refs.formDate.validate(valid => {
        let id = []
        let prvpath = []
        this.formDate.ids.map(item => {
          id.push(item.id)
          prvpath.push(item.prvpath)
        })
        this.formDate.id = id
        this.formDate.prvpath = prvpath
        if (valid) {
          this.$apis.hibe.cipherDataQuery(this.formDate).then(res => {
            if (res) {
              localStorage.setItem('keyspath', res.data.keyspath)
              localStorage.setItem('paramspath', res.data.paramspath)
              localStorage.setItem('path', this.formDate.path)
              localStorage.setItem('orgid', this.formDate.orgid)
              this.$emit('getPath')
              this.formDate.params = res.data
              this.$message.success('链上数据查询成功!')
            }
          })
        }
      })
    },

    addIds() {
      this.formDate.ids.push({
        value: '',
        key: Date.now()
      })
    },
    removeId(item) {
      var index = this.formDate.ids.indexOf(item)
      if (index !== -1) {
        this.formDate.ids.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.cipherDataQuery-wrapper {
  @include adaptation(
    (
      --common-gap-16: 16px
    )
  );
  /deep/ .el-form-item__content {
    display: flex;

    :not(:first-child) {
      margin-left: var(--common-gap-16);
    }
  }

  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
